import { SalesPerfSummary } from "./SalesPerfSummary/SalesPerfSummary"
import { ShareByRegion } from "./ShareByRegion/ShareByRegion"
import { ShareByDistrict } from "./ShareByDistrict/ShareByDistrict"
import { ActualTarget } from "./ActualTarget/ActualTarget"
import { ActualLastYear } from "./ActualLastYear/ActualLastYear"
import { SalesPerformanceByDM } from "./SalesPerformanceByDM/SalesPerformanceByDM"
import { DistrictComparativeMonthly } from "./DistrictComparativeMonthly/DistrictComparativeMonthly"
import { SalesPeformancePMR } from "./SalesPeformancePMR/SalesPeformancePMR"
import { EmployeeComparativeSales } from "./EmployeeComparativeSales/EmployeeComparativeSales"
import { EmployeeGrowthPerformance } from "./EmployeeGrowthPerformance/EmployeeGrowthPerformance"

export const ComparativeSalesPerformance = {
  "sections": [
    SalesPerfSummary,
    ShareByRegion,
    ShareByDistrict,
    ActualTarget,
    ActualLastYear,
    SalesPerformanceByDM,
    // DistrictComparativeMonthly,
    SalesPeformancePMR,
    EmployeeComparativeSales,
    EmployeeGrowthPerformance
  ]
}